export interface PersonalProject {
	id: number;
	title: string;
	subtitle: string;
	description: string;
	image: string;
	link: string;
	video?: string;
	features: string[];
	actions: { title: string; description: string }[];
	quotes: string[];
}

export const personalProjects: PersonalProject[] = [
	{
		id: 1,
		title: "Todo lo que no ves",
		subtitle: "Proyecto de sensibilización social",
		description:
			"Un proyecto integral que combina literatura, conferencias y talleres para sensibilizar sobre las heridas invisibles de la infancia, la educación emocional y la prevención de la violencia de género.",
		image: "/assets/book.jpg",
		link: "/todo-lo-que-no-ves",
		video: "https://www.youtube.com/embed/6O06xyrmSjQ",
		features: [
			"Novela publicada como herramienta educativa",
			"Ponencia escénica con danza y audiovisuales",
			"Talleres para familias y jóvenes",
			"Clubes de lectura y planes educativos",
		],
		actions: [
			{
				title: "Ponencia Escénica",
				description:
					"Conferencia artística que integra literatura, danza y audiovisuales",
			},
			{
				title: "Matrices de Aprendizaje",
				description:
					"Talleres experienciales para familias sobre comunicación y estilos educativos",
			},
			{
				title: "Lo que no te cuentan",
				description:
					"Talleres específicos para jóvenes sobre violencia de género y relaciones sanas",
			},
			{
				title: "Narrar nuestra propia historia",
				description:
					"Taller de escritura creativa como herramienta de autoconocimiento",
			},
			{
				title: "Clubes y Planes de Lectura",
				description:
					"Programa educativo utilizando la novela como herramienta de reflexión",
			},
		],
		quotes: [
			"Un proyecto que transforma la literatura en herramienta de cambio social",
			"Una iniciativa integral para sensibilizar sobre temas invisibles pero cruciales",
		],
	},
	{
		id: 2,
		title: "Asociación Equilibrio",
		subtitle: "Proyecto de transformación social",
		description:
			"Una asociación sin ánimo de lucro que fundé para trabajar por el bienestar social y comunitario, abierta a todos los colectivos y al liderazgo social. Un proyecto que busca crear impacto positivo y transformar realidades sociales.",
		image: "/assets/logo-asociacion.jpg",
		link: "/asociacion-equilibrio",
		features: [
			"Organización sin ánimo de lucro fundada por mí",
			"Enfoque en el bienestar social y comunitario",
			"Programas de liderazgo social",
			"Proyectos comunitarios transformadores",
		],
		actions: [
			{
				title: "Proyectos Sociales",
				description:
					"Iniciativas que abordan diferentes ámbitos de exclusión social",
			},
			{
				title: "Formación y Liderazgo",
				description:
					"Programas para desarrollar liderazgo social y comunitario",
			},
			{
				title: "Eventos y Actividades",
				description:
					"Organización de eventos que fomentan la participación ciudadana",
			},
			{
				title: "Colaboración",
				description: "Trabajo en red con otras organizaciones y entidades",
			},
		],
		quotes: [
			"Un proyecto que nació de mi compromiso con la transformación social",
			"Creando espacios de liderazgo y bienestar comunitario",
		],
	},
];
